module.exports = __webpack_public_path__ + "static/media/Enquiry.c1fbdf12.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/v2/workshop/Enquiry.png
// module id = 401
// module chunks = 1 2 3